import React, { useEffect, useState, useRef } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import Spinner from "react-bootstrap/Spinner";

//API
import ItemService from "../../../../services/supplier_appCommonService";
import SupplierConstants from "../../../../common/SupplierConstants";
import DataTable from "react-data-table-component";
import { currencyFormat, formatNumber } from "../../../../common/Validations";
import toast from "react-hot-toast";

import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import { useDispatch } from "react-redux";
import { getInvoiceList } from "../../../../redux/feature/supplier_app/purchasingSlice";

const POInvoiceUploadModal = React.forwardRef((props, ref) => {
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  const dispatch = useDispatch();

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const modalData = {
    title: "Invoice Creation",
    successMsg: "",
  };

  const [parentInfo, setParentInfo] = useState();
  const [uploadStatus, setUploadStatus] = useState(false);
  const [viewInvoiceDataStatus, setViewInvoiceDataStatus] = useState(false);
  const [getInvoiceLineItem, setInvoiceLineItem] = useState([]);
  console.log(">>getInvoiceLineItem",getInvoiceLineItem)

  const [getHeaderData, setHeaderData] = useState(false);
  const [disabled, setDisabled] = useState(false);
  console.log(">>getHeaderData",getHeaderData)

  // const [data, setData] = useState([]);
  const [totalOrderQuantity, setTotalOrderQuantity] = useState(0);

  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [wasModalShown, setWasModalShown] = useState(false);

  //   const totalTaxAmount = getHeaderData?.items?.reduce((acc, curr) => acc + curr.taxAmount, 0);

  // console.log(">>totalTaxAmount",totalTaxAmount)
  const [invoiceData, setInvoiceData] = useState({
    vendorInvoiceNo: "",
    vendorInvoiceDate: "",
    vendorBasicValue: "",
    vendorTotalInvoiceValue: "",
    dispInvoiceStatusHeader: "",
    dispCreatedBy: "",
    dispCreatedByName: "",
    deliveryName: "",
    dispTotalQty: "",
    dispBasicPricePerUnit: "",
    dispBasicPrice: "",
    dispCGST: "",
    dispSGST: "",
    dispTransporterCode: "",
    dispTransporterName: "",
    dispVehieleRegNo: "",
    dispCustomerCode: "",
    items: [],
    dispCompanyBankDetails: [],
    invoiceBillDocument: "",
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    currencyCode: "",
    currency: "",
    vendorCode: "",
    vendorName: "",
    paymentTerms: "",
    incoTerms: "",
    companyCodeCode: "",
    purchaseType: "",
    invoiceType: "",
  });

  const columns = [
    {
      name: "Sl.No",
      selector: (row) => row.slNo,
      sortable: true,
      width: "80px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.slNo} </p>
        </div>
      ),
    },
    {
      name: "Material",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialLongText} </p>
        </div>
      ),
    },
    {
      name: "Customer",
      selector: (row) => row.customerName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.customerName} </p>
        </div>
      ),
    },
    {
      name: "Qty",
      selector: (row) => row.orderQuantityLoad,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.orderQuantityLoad} </p>
        </div>
      ),
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.unitPrice} </p>
        </div>
      ),
    },
    {
      name: "Total Amount",
      selector: (row) => row.netValue,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.netValue} </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    setParentInfo(props?.invoiceinfo);
    if (props?.viewInvoiceData) {
      setInvoiceData(props?.viewInvoiceData);
      setViewInvoiceDataStatus(true);
    } else {
      setInvoiceData({
        vendorInvoiceNo: "",
        vendorInvoiceDate: "",
        vendorBasicValue: "",
        vendorTotalInvoiceValue: "",
        dispInvoiceStatusHeader: "",
        dispCreatedBy: "",
        dispCreatedByName: "",
        deliveryName: "",
        dispTotalQty: "",
        dispBasicPricePerUnit: "",
        dispBasicPrice: "",
        dispCGST: 0,
        dispSGST: 0,
        dispTransporterCode: "",
        dispTransporterName: "",
        dispVehieleRegNo: "",
        dispCustomerCode: "",
        items: [],
        dispCompanyBankDetails: [],
        invoiceBillDocument: "",
        purchasingDocumentNr: "",
        purchasingDocumentDate: "",
        purchasingDocumentValue: "",
        currencyCode: "",
        currency: "",
        vendorCode: "",
        vendorName: "",
        paymentTerms: "",
        incoTerms: "",
        companyCodeCode: "",
        purchaseType: "",
        invoiceType: "",
        dispgst: 0,
      });
      setInvoiceLineItem([]);
    }

    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  useEffect(() => {
    const items = invoiceData.items || [];

    // ✅ Calculate total basic amount
    const totalBasicAmount = items.reduce((acc, item) => {
      const amount = parseFloat(item.basicAmount) || 0;
      return acc + amount;
    }, 0);

    // ✅ Calculate GST
    const gst = (totalBasicAmount * 18) / 100;
    const cgst = gst / 2;
    const sgst = gst / 2;

    // ✅ Calculate total order quantity
    const totalQuantity = items.reduce((acc, item) => {
      const qty = parseFloat(item.orderQuantityLoad) || 0;
      return acc + qty;
    }, 0);

    // ✅ Update invoice data (GST)
    setInvoiceData((prev) => ({
      ...prev,
      dispgst: gst.toFixed(2),
      totalOrderQuantity: totalQuantity,
      vendorTaxValue: gst.toFixed(2),
      dispCGST: cgst.toFixed(2),
      dispSGST: sgst.toFixed(2),
    }));

    // ✅ Update total order quantity
    setTotalOrderQuantity(totalQuantity);
  }, [invoiceData.items]);

  const handleFileChange = (event) => {
    // const selectedFile = event.target.files[0];
    setFile(event.target.files[0]);
  };

  const selectFile = () => {
    fileInputRef.current.click();
  };
  const cancelInvoice = () => {
    setFile(null);
  };

  const uploadInvoice = async () => {
    setUploadStatus(true);
    if (file) {
      // Create FormData and append the file
      const formData = new FormData();
      formData.append("file", file);
      formData.append("module", "Invoice");
      formData.append("filePath", "invoice");

      await ItemService.uploadInvoiceOCR(formData).then((item) => {
        setInvoiceLineItem(item?.data?.items);
        setInvoiceData({
          vendorInvoiceNo: item?.data?.documentNumber,
          vendorInvoiceDate: item?.data?.generatedDate,
          vendorBasicValue: parseFloat(item?.data?.netValue),
          vendorTotalInvoiceValue: item?.data?.orderTotalValue,
          dispInvoiceStatusHeader: item?.data?.invoiceStatusHeader,
          dispCreatedBy: item?.data?.createdBy,
          dispCreatedByName: item?.data?.createdByName,
          deliveryName: item?.data?.deliveryName,
          dispTotalQty: item?.data?.totalQty,
          dispBasicPricePerUnit: item?.data?.basicPricePerUnit,
          dispBasicPrice: item?.data?.basicPrice,

          dispCGST: item?.data?.totals?.totalCgst,
          dispSGST: item?.data?.totals?.totalSgst,

          dispTransporterCode: item?.data?.transporterCode,
          dispTransporterName: item?.data?.transporterName,
          dispVehieleRegNo: item?.data?.vehieleRegNo,
          dispCustomerCode: item?.data?.customerCode,
          items: item?.data?.items,
          dispCompanyBankDetails: item?.data?.companyBankDetails,
          invoiceBillDocument: item?.data?.attachmentId,

          purchasingDocumentNr: getHeaderData?.purchasingDocumentNr,
          purchasingDocumentDate: getHeaderData?.purchasingDocumentDate,
          purchasingDocumentValue: getHeaderData?.purchasingDocumentValue,

          currencyCode: getHeaderData?.currencyCode,
          currency: getHeaderData?.currency,

          vendorCode: getHeaderData?.vendorCode,
          vendorName: getHeaderData?.vendorName,
          paymentTerms: getHeaderData?.paymentTerms,
          incoTerms: getHeaderData?.incoTerms,
          companyCodeCode: getHeaderData?.companyCodeCode,
          purchaseType: getHeaderData?.purchaseType,

          invoiceType: "OCR",
        });
        setFile(null);
      });
      setUploadStatus(false);
    } else {
      // alert('Please select a file first.');
    }
  };

  //handle cancel modal
  const handleCancel = () => {
    props.onHide();
  };

  useEffect(() => {
    if (!getShowSuccessModal && wasModalShown) {
      props.onHide(); // Call only when modal transitions from true → false
      setWasModalShown(false); // Reset tracker
    }
  }, [getShowSuccessModal, wasModalShown, props]);
  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const handleSave = async () => {
    const obj = {
      data: {
        ...invoiceData,
        ...parentInfo,
      },
    };
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    try {
      setDisabled(true);

      const item = await ItemService.addInvoice(obj);

      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        setWasModalShown(true);

        dispatch(getInvoiceList());
        // props.onsuccessdata(obj);
        //   props.onHide();
      } else {
        toast.error(item?.message || "Please try again!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error("Error while saving invoice:", error);
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
      setDisabled(false);
    }
  };

  const loadInitialPageData = async () => {
    // setLoading(true);

    if (props?.invoiceinfo?.purchasingDocumentNr) {
      let obj = {
        documentNumber: props?.invoiceinfo?.purchasingDocumentNr,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.getPurchaseOrderDetail(obj).then((item) => {
        // console.log(">> Details res!", item);
        if (item?.status === 200) {
          // setHeaderData(item?.data);
          setHeaderData(item?.data);
          // dispatch(addPoSelectedDetails(item?.data));
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });

      // setLoading(false);
    }
  };
  useEffect(() => {
    loadInitialPageData();
    // eslint-disable-next-line
  }, [props]);

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Invoice Confirmation - {parentInfo?.purchasingDocumentNr}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Upload invoice details */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">UI</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Upload Invoice details</span>
                  <span className="subHeaderTitle">Invoice details</span>
                </Col>
                {!viewInvoiceDataStatus && (
                  <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                    <Col
                      xs={6}
                      md={6}
                      lg={6}
                      className="d-flex justify-content-end mr-2 mt-1"
                    >
                      {file && (
                        <p>
                          File: <b>{file.name}</b>{" "}
                        </p>
                      )}
                    </Col>
                    <Col xs={6} md={3} lg={3} className="">
                      {!file && (
                        <button onClick={selectFile} className="btnTable">
                          <i className="bi bi-upload mr-2"></i>
                          Select Invoice
                        </button>
                      )}
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />

                      {file && (
                        <>
                          {!uploadStatus && (
                            <button
                              className="btnTable"
                              onClick={uploadInvoice}
                            >
                              <i className="bi bi-upload mr-2"></i>
                              Upload
                            </button>
                          )}

                          {uploadStatus && (
                            <button className="btnTable" disabled={true}>
                              <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                              Loading...
                            </button>
                          )}
                        </>
                      )}
                    </Col>
                    {file && (
                      <Col xs={6} md={1} lg={1} className="">
                        <button className="btnDelete" onClick={cancelInvoice}>
                          <i className="bi bi-x-circle"></i>
                        </button>
                      </Col>
                    )}
                  </Col>
                )}
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice Number"
                            name="vendorInvoiceNo"
                            id="vendorInvoiceNo"
                            value={invoiceData?.vendorInvoiceNo}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice Date"
                            name="vendorInvoiceDate"
                            id="vendorInvoiceDate"
                            value={invoiceData?.vendorInvoiceDate}
                            disabled={true}
                          />
                        </Col>
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice Status"
                            name="dispInvoiceStatusHeader"
                            id="dispInvoiceStatusHeader"
                            value={invoiceData?.dispInvoiceStatusHeader}
                            disabled={true}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Created By"
                            name="dispCreatedBy"
                            id="dispCreatedBy"
                            value={invoiceData?.dispCreatedBy}
                            disabled={true}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Created By Name"
                            name="dispCreatedByName"
                            id="dispCreatedByName"
                            value={invoiceData?.dispCreatedByName}
                            disabled={true}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Delivery"
                            name="vendorName"
                            id="vendorName"
                            value={invoiceData?.vendorName}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Qty"
                            name="totalOrderQuantity"
                            id="totalOrderQuantity"
                            value={totalOrderQuantity}
                            disabled={true}
                          />
                        </Col>

                        {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Basic Price Per Unit"
                            name="dispBasicPricePerUnit"
                            id="dispBasicPricePerUnit"
                            value={invoiceData?.dispBasicPricePerUnit}
                            disabled={true}
                          />
                        </Col> */}

                        <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Basic Price"
                            name="dispBasicPrice"
                            id="dispBasicPrice"
                            // value={invoiceData?.dispBasicPrice}
                            value={formatNumber(
                              invoiceData?.vendorBasicValue,
                              "comma"
                            )}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="CGST"
                            name="dispCGST"
                            id="dispCGST"
                            value={invoiceData?.dispCGST}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="SGST"
                            name="dispSGST"
                            id="dispSGST"
                            value={invoiceData?.dispSGST}
                            disabled={true}
                          />
                        </Col>
                        {/*                          <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="GST"
                            name="dispCGST"
                            id="dispCGST"
                            value={invoiceData?.dispCGST}
                            disabled={true}
                          />
                        </Col> */}

                        {/* <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Net Value"
                            name="vendorBasicValue"
                            placeholder="0.00"
                            id="vendorBasicValue"
                            value={formatNumber(
                              invoiceData?.vendorBasicValue,
                              "comma"
                            )}
                            disabled={true}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Total Amount"
                            name="vendorTotalInvoiceValue"
                            placeholder="0.00"
                            id="vendorTotalInvoiceValue"
                            value={formatNumber(
                              invoiceData?.vendorTotalInvoiceValue,
                              "comma"
                            )}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <p className="m-0 p-0 fw-medium">View Attachments</p>
                          {invoiceData?.invoiceBillDocument ? (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(invoiceData?.invoiceBillDocument)
                              }
                            />
                          ) : (
                            "--"
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {/* Header Details */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility2}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">HD</span>
                </Col>
                <Col xs={12} md={2} lg={2}>
                  <span className="headerTitle">Header Details</span>
                  <span className="subHeaderTitle"> </span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isCardVisible2 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Document Number"
                      name="purchasingDocumentNr"
                      placeholder=""
                      value={getHeaderData?.purchasingDocumentNr || ""}
                      disabled={true}
                    />
                  </Col>
                  {/* <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Status"
                                  name="statusHeader"
                                  placeholder=""
                                  value={getHeaderData?.statusHeader || ""}
                                  disabled={true}
                                />
                              </Col> */}
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Document Date"
                      name="purchasingDocumentDate"
                      placeholder=""
                      value={getHeaderData?.purchasingDocumentDate || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Net Value"
                      name="purchasingDocumentValue"
                      placeholder=""
                      value={currencyFormat(
                        Number(getHeaderData?.purchasingDocumentValue).toFixed(
                          2
                        )
                      )}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Currency"
                      name="currency"
                      placeholder=""
                      value={`${getHeaderData?.currencyCode} - ${getHeaderData?.currency}`}
                      disabled={true}
                    />
                  </Col>

                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Vendor Code"
                      name="vendorCode"
                      placeholder=""
                      value={getHeaderData?.vendorCode || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Vendor Name"
                      name="vendorName"
                      placeholder=""
                      value={getHeaderData?.vendorName || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Payment Terms"
                      name="paymentTerms"
                      placeholder=""
                      value={getHeaderData?.paymentTerms || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Inco Terms"
                      name="incoTerms"
                      placeholder=""
                      value={getHeaderData?.incoTerms || ""}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Company Code "
                      name="companyCodeCode"
                      id="companyCodeCode"
                      value={getHeaderData?.companyCodeCode}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Purchse Type"
                      name="purchasingRemark"
                      placeholder=""
                      value={getHeaderData?.purchaseType || ""}
                      disabled={true}
                    />
                  </Col>
                  {/* <Col
                    xs={12}
                    md={4}
                    lg={4}
                    className="commTopButtonRightLeftPadding mt-4 pt-3"
                  >
                    <div>
                      <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                        Header Text
                      </label>
                      <span
                        style={{ marginLeft: "15px" }}
                        // onClick={() =>
                        //   headerTextShowModal(getHeaderData?.headerTextData)
                        // }
                      >
                        <i className="bi bi-calendar2-week iconTable"></i>
                      </span>
                      <span className="suppliersIcon">
                        {" "}
                        {getHeaderData?.headerTextData?.length || 0}{" "}
                      </span>
                    </div>
                  </Col> */}
                </Row>
              </div>
            </div>
          </div>
        </div>

        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Item Details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible3 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <DataTable
                      title=""
                      columns={columns}
                      data={getInvoiceLineItem}
                      // progressPending={loading}
                      pagination
                      // paginationServer
                      // paginationTotalRows={totalRows}
                      // onChangeRowsPerPage={handlePerRowsChange}
                      // onChangePage={handlePageChange}
                      selectableRows
                      paginationRowsPerPageOptions={
                        SupplierConstants.ROW_PER_PAGE
                      }
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
        <SuccessRegisterModal
          show={getShowSuccessModal}
          onHide={() => hideSuccessModal()}
          modaldata={getModalInfo}
          // aftersuccess={Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE}
        />
        {!viewInvoiceDataStatus && (
          <Row className="my-4 ">
            <Col
              lg={{ span: 2, offset: 8 }}
              className="d-flex justify-content-end"
            >
              <button className="btnTable btn-danger" onClick={handleCancel}>
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end">
              <button
                className="btnTable"
                onClick={handleSave}
                disabled={disabled}
              >
                Save
              </button>
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
});

export default POInvoiceUploadModal;
